import React from 'react';
import { Tooltip } from 'antd';
import { Wrapper } from './styled';

interface IParams {
  text: string | React.ReactNode;
  left: number | string;
}

const CustomChartTooltip = ({ text, left }: IParams) => {
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const getPopupContainer = React.useCallback(() => {
    if (wrapperRef.current && wrapperRef.current.parentElement) {
      return wrapperRef.current.parentElement;
    }
    return document.body;
  }, [wrapperRef.current]);
  if (!text) {
    return null;
  }
  return (
    (<Tooltip
      title={text}
      open
      placement="right"
      getPopupContainer={getPopupContainer}
    >
      <Wrapper left={left} ref={wrapperRef} />
    </Tooltip>)
  );
};

export default CustomChartTooltip;
